import React, { FC } from 'react';
import classNames from 'classnames';

import { Badge, HeaderText, RichText } from '@/components';
import { Document } from '@contentful/rich-text-types';
import { TypeImage, TypeMediaTextTitleFields } from '@/core/generated-types';
import { HeaderSize } from '@/components/ui/HeaderText';
import { CONTENT_TYPE_MEDIA_TEXT_TITLE } from '@/core/constants';
import { Image } from '@/components/ui/Image';
import MediaTextTitleModal from '../MediaTextTitle/MediaTextTitleModal';

const ProductBlock: FC<TypeMediaTextTitleFields> = (props) => {
  const {
    layoutType,
    image,
    textBody,
    textHeading,
    id,
    narrowMobilePadding,
    badge,
    modal,
  } = props;
  const blockSmall = layoutType === CONTENT_TYPE_MEDIA_TEXT_TITLE.SMALL;
  const blockMedium = layoutType === CONTENT_TYPE_MEDIA_TEXT_TITLE.MEDIUM;
  const blockLarge = !blockMedium && !blockSmall;
  return (
    <div
      id={id}
      className={classNames(
        'flex w-full items-start gap-2 text-center h-full',
        {
          'flex-row': !blockLarge,
          'mx-auto flex-col items-center': blockLarge,
        },
      )}
    >
      <div
        className={classNames('flex flex-none', {
          'h-[72px] w-[72px] items-start': blockMedium,
          'h-[48px] w-[48px] items-start md:h-[72px] md:w-[72px]': blockSmall,
          'lg:h-88 lg:w-88 items-center': blockLarge,
        })}
      >
        <div className={badge ? 'relative' : undefined}>
          {badge && (
            <div className="absolute z-[1] -top-4">
              <Badge {...badge.fields} />
            </div>
          )}
          {image && (
            <Image
              imageData={image as TypeImage}
              alt={image.fields?.altText}
              width={!blockLarge ? 72 : 360}
              height={!blockLarge ? 72 : 360}
              className="h-auto w-full"
            />
          )}
        </div>
      </div>
      <div
        className={classNames('flex flex-col gap-1 text-center', {
          'justify-left text-left': !blockLarge,
          'justify-center text-center': blockLarge,
          'px-12': !narrowMobilePadding,
          'pl-2': narrowMobilePadding,
        })}
      >
        <HeaderText
          size={HeaderSize.H3}
          text={textHeading}
          classes={`${!blockLarge ? 'text-left' : 'text-center'}`}
        />
        {textBody && (
          <div
            className={classNames('leading-6', {
              'text-left': !blockLarge,
              'text-base md:text-lg': narrowMobilePadding,
              'text-lg': !narrowMobilePadding,
            })}
            data-testid={`product-block-text-paragraph`}
          >
            <RichText content={textBody as Document} />
          </div>
        )}
      </div>
      {modal && <MediaTextTitleModal fields={modal.fields} />}
    </div>
  );
};

export default ProductBlock;
